/**
 * Calendar event-type configuration — shared across all calendar components.
 *
 * Extracted to avoid circular imports between CalendarPage and its children.
 */

export const EVENT_TYPE_CONFIG = {
  shoot_day: { label: 'Shoot Day', color: 'bg-blue-500', text: 'text-blue-500', dot: 'bg-blue-500', light: 'bg-blue-500/10 text-blue-500 border-blue-500/20' },
  deadline:  { label: 'Deadline',  color: 'bg-red-500',  text: 'text-red-500',  dot: 'bg-red-500',  light: 'bg-red-500/10 text-red-500 border-red-500/20' },
  review:    { label: 'Review',    color: 'bg-purple-500', text: 'text-purple-500', dot: 'bg-purple-500', light: 'bg-purple-500/10 text-purple-500 border-purple-500/20' },
  meeting:   { label: 'Meeting',   color: 'bg-emerald-500', text: 'text-emerald-500', dot: 'bg-emerald-500', light: 'bg-emerald-500/10 text-emerald-500 border-emerald-500/20' },
  custom:    { label: 'Custom',    color: 'bg-amber-500', text: 'text-amber-500', dot: 'bg-amber-500', light: 'bg-amber-500/10 text-amber-500 border-amber-500/20' },
};

export const ALL_EVENT_TYPES = Object.keys(EVENT_TYPE_CONFIG);
